import React from "react";
export default function EmptyNode(props) {
    const { radius, x, y } = props;
    return React.createElement("rect", { width: radius, height: radius, x: x - radius / 2, y: y - radius / 2, strokeWidth: "2px" });
}
